type ApiResult = { err?: unknown; res?: any; [key: string]: unknown };

/**
 * Keep one successful answer per method and arguments for the page's life.
 *
 * For settings that are the same for every visitor and change at most once a
 * deploy. A failure is not kept, so the next caller asks again. Each caller
 * gets its own copy, so one caller changing its answer cannot change another's.
 */
export function createSessionCache(fetch: (method: string, args: any) => Promise<ApiResult>) {
  const answers = new Map<string, Promise<ApiResult>>();

  const call = async (method: string, args: any = {}) => {
    const key = `${method}:${JSON.stringify(args)}`;
    let answer = answers.get(key);
    if (!answer) {
      answer = fetch(method, args).then((result) => {
        if (result?.err || !result?.res) answers.delete(key);
        return result;
      });
      answers.set(key, answer);
    }
    const result = await answer;
    return result?.res ? { ...result, res: JSON.parse(JSON.stringify(result.res)) } : result;
  };

  return { call, clear: () => answers.clear() };
}
